import Vue from "vue";
import Vuex from "vuex";
import receiptStore from "./modules/receipt";
import signStore from "./modules/sign";
import accessControlStore from "./modules/accessControl";
import gateStore from "./modules/gate";
import scanStore from "./modules/scan";
import activationStore from "./modules/activation";
import quickServiceStore from "./modules/quickService";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  getters: {},
  actions: {},
  modules: {
    receiptStore,
    signStore,
    accessControlStore,
    gateStore,
    scanStore,
    activationStore,
    quickServiceStore,
  },
});
